import React, {useEffect, useState, useContext} from 'react';
import styled from "styled-components";
import {useAuth0} from "@auth0/auth0-react";
import {Col, Row} from "react-materialize";

import UserInfoCard from "../Components/Settings/UserInfoCard.react";
import useFetch from "../Utilities/API/useFetch.react";
import AuthorizedUsers from "../Components/Settings/AuthorizedUsers/AuthUsers.react";
import AuthRoles from "../Components/Settings/AuthRoles/AuthRoles.react";

import AppContext from "../Context/AppContext.react";

const StyledSettingsPage = styled.div`
  margin-top: 6rem;
  width: 100%;

  .top-half {
    background-color: #3388BD;
    height: 100%;
    width: 100vw;
    padding-left: 3.6rem;
    padding-bottom: 3rem; 
    
    .top-formatter {
      display: flex;
      align-items: center;
    }
  }
  
  .bottom-half {
    background: #EFEFEF;
    height: 100%;
    min-height: 60rem;
    padding-left: 3rem;
    padding-right: 3rem;
    padding-bottom: 4rem;
  }
  
  .row {
    padding: 1rem;
    margin-bottom: 0;
  }
`

const SettingsPage = () => {
  const {permissions, user} = useContext(AppContext);
  const [loading, setLoading] = useState(true);
  const [authUsers, setUsers] = useState(null);
  const [authRoles, setRoles] = useState(null);
  const [fetchUrl] = useFetch();

  const fetchAuthData = async () => {
    let roles = await fetchUrl('fetchAuthRoles');
    let users = await fetchUrl('fetchAuthUsers');
    setRoles(roles)
    setUsers(users)
    setLoading(false);
  }

  useEffect(() => {
    if (user) {
      fetchAuthData();
    }
  }, [user])

  const showUserActions = permissions.includes("user:write");
  const showUsers = permissions.includes("user:view");

  return (
    <StyledSettingsPage>
      <div className={'top-half'}>
        <Row className={'top-formatter'}>
          <AuthRoles roles={authRoles} loading={loading} />
          <UserInfoCard user={user} />
        </Row>
      </div>
      <div className={'bottom-half'}>
        <Row>
          <Col s={12} m={12} l={12}>
            {
              showUsers && <AuthorizedUsers showActions={showUserActions} users={authUsers} authRoles={authRoles} loading={loading} />
            }
          </Col>
        </Row>
      </div>
    </StyledSettingsPage>
  )
}

export default SettingsPage;